import { sortDomainList } from 'components/DomainList/helpers/index';
import { filterEmailsList } from 'components/EmailList/helpers';

import { InitialState, actionTypes } from './emailContext';
import { getDefaultDomain } from './helpers';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_DOMAINS_LIST_IS_LOADING:
      state.domainsListIsLoading = action.isLoading;

      return;
    case actionTypes.SET_DOMAINS_LIST:
      state.domainsList = sortDomainList(action.domainsList);
      state.defaultDomain = getDefaultDomain(action.domainsList);

      return;

    case actionTypes.SET_EMAILS_LIST_IS_LOADING:
      state.emailsListIsLoading = action.isLoading;

      return;
    case actionTypes.SET_EMAILS_LIST:
      state.emailsList = filterEmailsList(action.emailsList);

      return;
    case actionTypes.SELECT_DOMAIN:
      state.selectedDomain = action.selectedDomain;

      return;
    case actionTypes.REMOVE_DOMAIN:
      state.domainsList = state.domainsList.filter(i => {
        return i.name !== action.selectedDomain;
      });

      return;
    default:
      return InitialState;
  }
};
